import { DIVISIONS_TYPE } from '../constants';

const useManageDivisionValue = ({ divisionFilterValue, divisionIds, divId }) => {
  if (!!divId) return [divId];
  if (divisionFilterValue === DIVISIONS_TYPE.DIVISIONS) return divisionIds;

  return [];
};

export default useManageDivisionValue;